export const en = {
  links: {
    home: "Home",
    mission: "Mission",
    services: "Services",
    contact: "Contact",
    privacy: "Privacy Policy",
  },
  contact: {
    title: "Contact Infomation",
    findUs: "Find us",
    btnWhatsapp: "btn_whatsapp_en.png",
    Call: "Call 754.752.1888",
    SMS: "MSG 754.752.1888",
    WhatsappMsg: "WhatsApp 754.276.1746",
    AfterHours:
      "PLEASE NOTE: AFTER HOURS AND WEEKENDS - We are only available via text message at:",
  },
  img: {
    img1: "1_en2.jpg",
    img2: "2_en2.jpg",
  },
  footer: {
    quickLinks: "Quick Links",
    bookAppointment: "Book Appointment",
  },
  altsImgs: {
    btnWhatsapp: "Start whatsapp chat button.",
    logoDiverse: "Diverse Care Now",
  },
};
